import { render, staticRenderFns } from "./HsabClaimAccount.vue?vue&type=template&id=2b23a026&scoped=true"
import script from "./HsabClaimAccount.vue?vue&type=script&lang=ts"
export * from "./HsabClaimAccount.vue?vue&type=script&lang=ts"
import style0 from "./HsabClaimAccount.vue?vue&type=style&index=0&id=2b23a026&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b23a026",
  null
  
)

export default component.exports